import React from "react";

const DNPReport = () => {
  return <></>;
};

export default DNPReport;
